import React, { Component } from "react";
import { TextField } from "reactackle";
import { isMobile } from "react-device-detect";
import moment from "moment";

class HighComm extends Component {
  state = {
    searchVal: ""
  };

  //single method that work for all fields
  //takes incoming id of the field and then adds field data to state
  stateChangeHandler = (val, id, isPayload) => {
    // console.log(
    //   "val: " + JSON.stringify(val) + " id: " + id + " isPayload: " + isPayload
    // );
    let tmpState = {};
    tmpState[id] = val;

    if (isPayload) {
      this.setState(prevState => {
        if (prevState && prevState.data.payload !== null) {
          return {
            ...prevState,
            data: {
              ...prevState.data,
              payload: {
                ...prevState.data.payload,
                ...tmpState
              }
            }
          };
        } else {
          return {
            ...prevState,
            data: {
              path: prevState.data.path,
              payload: {
                ...tmpState
              }
            }
          };
        }
      });
    } else {
      this.setState(prevState => {
        return {
          ...prevState,
          ...tmpState
        };
      });
    }
  };

  getActionButton = (iconName, title, stateValue, bucket) => {
    return (
      <div
        style={{
          textAlign: "center",
          width: "100%"
        }}
      >
        <div
          style={{
            width: "50%",
            padding: "1px",
            textAlign: "center",
            border: "1px solid gainsboro",
            borderRadius: isMobile ? "5px" : "0px",
            backgroundColor:
              stateValue === title ? "rgb(30, 101, 144)" : "gainsboro",
            margin: "auto",
            padding: "6px",
            fontWeight: "bold",
            color: stateValue === title ? "white" : "black",
            fontSize: "12px"
          }}
          onClick={() => {
            if (title !== stateValue) {
              if (
                window.confirm(
                  "Please confirm if you would like to change the status of this application to " +
                    title +
                    "?"
                )
              ) {
                this.updateStatus(bucket, title);
              }
            }
          }}
        >
          <div>
            <i className={iconName}></i> {title}
          </div>
        </div>
      </div>
    );
  };

  updateStatus = (bucket, newStatus) => {
    let cloudPath = "hCommApps/" + bucket.key;
    this.props.firebase.db
      .ref("/" + cloudPath)
      .once("value")
      .then(snap => {
        return snap.ref.set({
          ...bucket,
          status: newStatus
        });
      })
      .catch(err => {
        console.log(err);
        return console.log("some error: " + err);
      })
      .then(err => {
        //clear the bucket
        this.props.firebase.db
          .ref("/myPassApps" + "/" + bucket.cellPhone + "/" + bucket.key)
          .once("value")
          .then(snap => {
            //console.log("ta da");
            this.props.onNotifyUsers(
              "You passport application is now under the status : " + newStatus,
              [bucket.cellPhone]
            );
            return snap.ref.set({
              ...bucket,
              status: newStatus
            });
          })
          .catch(err => {
            console.log(err);
            return console.log("some error: " + err);
          })
          .then(err => {});
      });
  };

  getApplicationsList = listOfApplicationsAll => {
    //console.log(JSON.stringify(listOfApplications));

    let listOfApplications = [];

    if (this.state.searchVal === "") {
      listOfApplications = listOfApplicationsAll;
    } else {
      let searchVal = this.state.searchVal.toLowerCase();
      listOfApplications = listOfApplicationsAll.filter(app => {
        return (
          app.passportNo.toLowerCase().includes(searchVal) ||
          app.name.toLowerCase().includes(searchVal) ||
          app.applicationDate.toLowerCase().includes(searchVal) ||
          app.status.toLowerCase().includes(searchVal) ||
          app.cellPhone.includes(searchVal)
        );
      });
    }

    if (listOfApplications && listOfApplications.length > 0) {
      return listOfApplications.map(passApp => {
        return (
          <div
            style={{
              margin: "10px",
              padding: "5px",
              backgroundColor: "white",
              marginBottom: "15px",
              borderRadius: "5px"
            }}
          >
            <table className="table table-striped table-bordered">
              <tbody>
                <tr>
                  <td>Name</td>
                  <td>{passApp.name}</td>
                </tr>
                <tr>
                  <td>Cell No.</td>
                  <td>{passApp.cellPhone}</td>
                </tr>
                <tr>
                  <td>Passport No.</td>
                  <td>{passApp.passportNo}</td>
                </tr>
                <tr>
                  <td>Application Date</td>
                  <td>{passApp.applicationDate}</td>
                </tr>
                <tr>
                  <td>Status</td>
                  <td>{passApp.status}</td>
                </tr>
              </tbody>
            </table>
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <td>Tap to update status</td>
                </tr>
                <tr>
                  <td>
                    {this.getActionButton(
                      "fa fa-clock",
                      "SUBMITTED",
                      passApp.status,
                      passApp
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {this.getActionButton(
                      "fa fa-clock",
                      "ACCEPTED",
                      passApp.status,
                      passApp
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {this.getActionButton(
                      "fa fa-clock",
                      "READY FOR COLLECTION",
                      passApp.status,
                      passApp
                    )}
                  </td>
                </tr>
                <tr>
                  <td>
                    {this.getActionButton(
                      "fa fa-clock",
                      "REJECTED",
                      passApp.status,
                      passApp
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        );
      });
    } else {
      return <div>No recs</div>;
    }
  };
  render() {
    return (
      <div>
        <div
          style={{
            margin: "5px",
            padding: "5px"
          }}
        >
          <div>
            <div
              style={{
                padding: "1px",
                textAlign: "right",
                border: "1px solid gainsboro",
                borderRadius: isMobile ? "5px" : "0px",
                backgroundColor: "white",
                zIndex: "-9"
              }}
            >
              <TextField
                value={this.state["searchVal"]}
                onChange={e => {
                  this.stateChangeHandler(e.value, "searchVal", false);
                }}
                fullWidth
                placeholder="Search..."
              />
            </div>
          </div>
        </div>
        <div>{this.getApplicationsList(this.props.applications)}</div>
      </div>
    );
  }
}

export default HighComm;



// WEBPACK FOOTER //
// ./src/app/components/Screens/landingPage/HighComm.jsx